import { render, staticRenderFns } from "./AddOutgoingCategory.vue?vue&type=template&id=bcd3170a&scoped=true&"
import script from "./AddOutgoingCategory.vue?vue&type=script&lang=js&"
export * from "./AddOutgoingCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddOutgoingCategory.vue?vue&type=style&index=0&id=bcd3170a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd3170a",
  null
  
)

export default component.exports